export enum Mini3SScenario {
    MINI_SEARCH_SCENARIO_NAME = 'owa.react.mini',
    MINI_MENTION_SCENARIO_NAME = 'owa.react.mini.atmentions',
    MINI_COMPOSE_SCENARIO_NAME = 'owa.react.mini.compose',
}
